export default {
  state: {
    default: {},
    exit: {}
  },

  getters: {
    getTripData(state) {
      return state.default;
    },

    getExitTripData(state) {
      return state.exit;
    }
  },

  mutations: {
    setTripData(state, data) {
      const isNull = data === null;

      state.default = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name: "",
        polyclinic_id: !isNull ? parseInt(data.polyclinic_id) : "",
        route_id: !isNull ? parseInt(data.route_id) : "",
        driver_id: !isNull ? parseInt(data.driver_id) : "",
        transport_id: !isNull ? parseInt(data.transport_id) : "",
      };
    },

    setExitTripData(state, data) {
      const isNull = data === null;

      state.exit = {
        id: !isNull ? data.id : "",
        trip_id: !isNull ? data.trip_id: "",
        trip_date: !isNull ? data.trip_date : "",
        trip_hour: !isNull ? data.trip_hour : "",
      };
    },
  },

  actions: {
    changeTripData(context, infos) {
      context.commit("setTripData", infos);
    },

    changeExitTripData(context, infos) {
      context.commit("setExitTripData", infos);
    }
  },
};
